import React from 'react';
import {
  AlertDialog,
  AlertDialogCloseButton,
  AlertDialogOverlay,
  useBreakpointValue,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import {
  StyledAlertDialogContent,
  StyledAlertDialogHeader,
  StyledAlertDialogFooter,
  StyledButton,
} from './styles';

interface CancellationDialogProps {
  isOpen: UseDisclosureReturn['isOpen'];
  onClose: UseDisclosureReturn['onClose'];
  onVisitCancel: () => void;
}

export const CancellationDialog: React.FC<CancellationDialogProps> = ({
  isOpen,
  onClose,
  onVisitCancel,
}) => {
  const cancelRef = React.useRef(null);
  const buttonVariant = useBreakpointValue(
    {
      base: 'ghost',
      xs: 'ghost',
      md: 'outline',
    },
    'outline',
  );

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay backdropFilter={{ base: 'none', md: 'blur(2px)' }}>
        <StyledAlertDialogContent>
          {buttonVariant === 'outline' && <AlertDialogCloseButton />}
          <StyledAlertDialogHeader>Отменить запись?</StyledAlertDialogHeader>

          <StyledAlertDialogFooter>
            <StyledButton
              ref={cancelRef}
              onClick={onClose}
              variant={buttonVariant}
              borderRadius={{ base: '0 0 0 8px', md: '16px' }}
              size="sm"
            >
              Нет
            </StyledButton>
            <StyledButton
              onClick={onVisitCancel}
              variant={buttonVariant}
              borderRadius={{ base: '0 0 8px 0', md: '16px' }}
              size="sm"
            >
              Да
            </StyledButton>
          </StyledAlertDialogFooter>
        </StyledAlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
